"use client"

type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[]
}

declare const window: WindowWithDataLayer

export const infoMenuClick = (text: string, category: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "info_menu_click",
      click_text: text,
      category1: category,
      element_name: "תפריט ריבועים ראשי",
    })
  }
}

export const infoClick = (
  text: string,
  subText: string,
  category: string,
  elementName: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "info_click",
      click_text: text,
      sub_click_text: subText,
      category1: category,
      element_name: elementName,
    })
  }
}

export const subInfoClick = (
  text: string,
  category: string,
  elementName: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "sub_info_click",
      click_text: text,
      category1: category,
      element_name: elementName,
    })
  }
}

export const busPaymentReportStep = (
  text: string,
  stepNumber: string,
  stepName: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "bus_payment_report_step",
      click_text: text,
      step_number: stepNumber,
      step_name: stepName,
      category1: "מידע לנוסעים",
      element_name: "תשלום תעריף מוגדל",
    })
  }
}

export const busPaymentReportError = (
  text: string,
  stepNumber: string,
  stepName: string,
  errorName: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "bus_payment_report_error",
      click_text: text,
      step_number: stepNumber,
      step_name: stepName,
      category1: "מידע לנוסעים",
      errorName: errorName,
      element_name: "תשלום תעריף מוגדל",
    })
  }
}

export const busPaymentReportSuccess = () => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "bus_payment_report_success",
      step_name: 3,
      category1: "מידע לנוסעים",
      element_name: "תשלום תעריף מוגדל",
    })
  }
}

export const pageStripFaq = (
  text: string,
  category: string,
  elementName: string,
  subText?: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "page_strip_faq",
      click_text: text,
      sub_click_text: subText,
      category1: category,
      element_name: elementName,
    })
  }
}

export const ravKavLocateStations = (text: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "rav_kav_locate_stations",
      click_text: text,
      category1: "מידע לנוסעים",
      element_name: "אפליקציות תשלום",
    })
  }
}

export const ravKavTypes = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "rav_kav_types",
      click_text: text,
      sub_click_text: subText,
      category1: "מידע לנוסעים",
      element_name: "אפליקציות תשלום",
    })
  }
}

export const methodsPaymentPublicTransport = (text: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "methods_payment_public_transport",
      click_text: text,
      category1: "מידע לנוסעים",
      element_name: "אפליקציות תשלום",
    })
  }
}

export const menuContactClick = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "menu_contact_click",
      click_text: text,
      sub_click_text: subText,
      category1: "מידע לנוסעים",
      element_name: "יצירת קשר",
    })
  }
}

export const applicationContactClick = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "application_contact_click",
      click_text: text,
      sub_click_text: subText,
      category1: "מידע לנוסעים",
      element_name: "יצירת קשר",
    })
  }
}

export const applicationRequestClick = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "application_request_click",
      click_text: text,
      sub_click_text: subText,
      category1: "מידע לנוסעים",
      element_name: "יצירת קשר",
    })
  }
}

export const applicationRequestSuccess = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "application_request_success",
      click_text: text,
      sub_click_text: subText,
      category1: "מידע לנוסעים",
      element_name: "יצירת קשר",
    })
  }
}

export const applicationRequestError = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "application_request_error",
      click_text: text,
      sub_click_text: subText,
      category1: "מידע לנוסעים",
      element_name: "יצירת קשר",
    })
  }
}

export const jobInfoClick = (
  text: string,
  subText: string,
  category: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "job_info_click",
      click_text: text,
      sub_click_text: subText,
      category1: category,
      element_name: "קריירה - מטה",
    })
  }
}

export const sendCvClick = (
  text: string,
  subText: string,
  category: string,
  element_name?: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "send_cv_click",
      click_text: text,
      sub_click_text: subText,
      category1: category,
      element_name: element_name || "קריירה - מטה",
    })
  }
}

export const sendCvSuccess = (
  text: string,
  subText: string,
  category: string,
  element_name?: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "send_cv_success",
      click_text: text,
      sub_click_text: subText,
      category1: category,
      element_name: element_name || "קריירה - מטה",
    })
  }
}

export const sendCvError = (
  text: string,
  subText: string,
  category: string,
  element_name?: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "send_cv_error",
      click_text: text,
      sub_click_text: subText,
      category1: category,
      element_name: element_name || "קריירה - מטה",
    })
  }
}

export const webMenuClick = (clickText: string, category: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "web_menu_click",
      click_text: clickText.toLowerCase(),
      category1: category.toLowerCase(),
      element_name: "תפריט ראשי",
    })
  }
}

export const footerMenuClick = (clickText: string, category: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "footer_menu_click",
      click_text: clickText.toLowerCase(),
      category1: category.toLowerCase(),
      element_name: "תפריט פוטר",
    })
  }
}

export const contactUsClick = (
  clickText: string,
  location: "בר עליון" | "עמוד פנו אלינו",
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "contact_us_click",
      click_text: clickText.toLowerCase(),
      category1: location,
      element_name: "רכיב יצירת קשר",
    })
  }
}
